export const AutogeneratedRiskTables = {
   "library" : {
      "annotation" : [ {
         "translatorOptions" : "",
         "type" : "CqlToElmInfo"
      } ],
      "identifier" : {
         "id" : "AutogeneratedRiskTables",
         "version" : "1.0.0"
      },
      "schemaIdentifier" : {
         "id" : "urn:hl7-org:elm",
         "version" : "r1"
      },
      "usings" : {
         "def" : [ {
            "localIdentifier" : "System",
            "uri" : "urn:hl7-org:elm-types:r1"
         }, {
            "localIdentifier" : "FHIR",
            "uri" : "http://hl7.org/fhir",
            "version" : "4.0.1"
         } ]
      },
      "includes" : {
         "def" : [ {
            "localIdentifier" : "FHIRHelpers",
            "path" : "FHIRHelpers",
            "version" : "4.0.1"
         } ]
      },
      "statements" : {
         "def" : [ {
            "name" : "GeneralScreening",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.12",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.04",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.4",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.05",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.96",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.42",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.78",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.07",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.46",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "25.21",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "27.37",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.01",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.14",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.13",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.8",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.45",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.27",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.27",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.94",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "25.73",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "33.34",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "26.27",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "34.53",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "48.86",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "53.16",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.3",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.82",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.99",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "13.31",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "11.27",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "15.36",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "27.76",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "33.24",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "36.14",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "42.65",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "60.17",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "63.93",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.5",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.54",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.63",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.05",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.89",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "15.33",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "17.85",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "33.03",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "41.17",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NO HISTORY",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "30.25",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "30.25",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.09",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.01",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.36",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.44",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.79",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.77",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.29",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.78",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.88",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "13.8",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "13.8",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.01",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.1",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.74",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.29",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.03",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.78",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.1",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.78",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "13.56",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "17.62",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "13.79",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "21.27",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "32.28",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "33.65",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.96",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.11",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.34",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "10.16",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.7",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "11.29",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "23.55",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "25.23",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.49",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.77",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.45",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.22",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.48",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.48",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "19.1",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "21.86",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.08",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.01",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.27",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.04",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.25",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.48",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.1",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.75",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.85",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "12.5",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "12.5",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.09",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.68",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.25",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.98",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.6",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.78",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "12.67",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "17.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "14.87",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "22.56",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "31.34",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "32.82",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.45",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.34",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.4",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "9.21",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.65",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "10.41",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "23.16",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "24.87",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.66",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.4",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.88",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.2",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.48",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.48",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-, HPV18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "18.58",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "22.1",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "Surveillance",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.9",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.35",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.59",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.33",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.33",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.33",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.34",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "44.45",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "44.46",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.06",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.99",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.06",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.2",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.36",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "9.49",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.97",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.47",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "22.06",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "28.59",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "32.64",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "40.14",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "43.96",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "49.49",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.4",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.41",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.62",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.26",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.94",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.94",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.94",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "50.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "50.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "33.33",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "33.33",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.14",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.06",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.78",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.39",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.1",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.66",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.66",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "11.11",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "11.11",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.96",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.36",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.13",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.59",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.59",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.59",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "23.81",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "23.81",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative/ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "36.36",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "36.36",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : " Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.29",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : " Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.12",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.17",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : " Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US, LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.6",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.46",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : " Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "19.81",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "51.72",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.28",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.22",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.23",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US, LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.56",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.94",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "19.3",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "53.12",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "15.63",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "24.11",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC_US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "14.3",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "27.1",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "20.88",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "25.94",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "41.58",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "56.96",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-,18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.55",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "7.9",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-,18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC_US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "8.77",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "11.88",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-,18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "13.39",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "history_prev_2",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "history",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive/NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV16-,18+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "39.77",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "49.17",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "ColposcopyResults",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "<CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.56",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.65",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "<CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.49",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.18",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "<CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.59",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.09",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "<CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.41",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.44",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "<CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.17",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.64",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "<CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.89",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.76",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.74",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.84",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive ASC-US",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.53",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.6",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.74",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.27",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-H",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.36",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.57",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AGC",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.32",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.82",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HSIL+",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.92",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.45",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "AIS",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "referral_screen_result",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cancer",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "type" : "Negate",
                              "operand" : {
                                 "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                                 "value" : "1",
                                 "type" : "Literal"
                              }
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Treatment",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "PostColposcopy",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.42",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.05",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.92",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.05",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.25",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.11",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.03",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.65",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.09",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "22.97",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "30.7",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.02",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.48",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.28",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.32",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.02",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "11.56",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "6.6",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "17.21",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.62",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "14.05",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "28.39",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "38.27",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.01",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.51",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.14",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.8",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.18",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.18",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.04",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.23",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.07",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.36",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.39",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.03",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.77",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.12",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.56",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.56",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "15.78",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "23.49",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "4.53",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.89",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.89",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : " HPV-negative/ASCUS/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.31",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : " HPV-negative/ASCUS/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.66",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.18",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative x2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.29",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative x2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.01",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.09",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Low Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative x2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.03",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "5-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "preColposcopyResult",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "postColposcopyPastHistory",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative x2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.14",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "PostTreatment",
            "context" : "Unfiltered",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.03",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "1.67",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.75",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "3.82",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "NILM",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "5.81",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "12.07",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ASC-US/LSIL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "10.22",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "20.8",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "17.54",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "17.54",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-positive",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "High Grade",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "52.7",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "62.88",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Colposcopy/Treatment",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "ALL",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.34",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "2.03",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative x2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.05",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.91",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative x2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.68",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "1-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "HPV-negative x3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.15",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.44",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "biopsy",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "hpv",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Cotest-negative x3",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "pap",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "none",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "value",
                     "value" : {
                        "type" : "Tuple",
                        "element" : [ {
                           "name" : "immediate",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.0",
                              "type" : "Literal"
                           }
                        }, {
                           "name" : "five_year",
                           "value" : {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "value" : "0.35",
                              "type" : "Literal"
                           }
                        } ]
                     }
                  }, {
                     "name" : "management",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "3-year follow-up",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "ClinicalSituations",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Tuple",
               "element" : [ {
                  "name" : "GeneralScreening",
                  "value" : {
                     "name" : "GeneralScreening",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "Surveillance",
                  "value" : {
                     "name" : "Surveillance",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "ColposcopyResults",
                  "value" : {
                     "name" : "ColposcopyResults",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "PostColposcopy",
                  "value" : {
                     "name" : "PostColposcopy",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "PostTreatment",
                  "value" : {
                     "name" : "PostTreatment",
                     "type" : "ExpressionRef"
                  }
               } ]
            }
         } ]
      }
   }
}

